export const NAME_TO_SLUG = {
  gmail: 'gmail',
  'outlook mail': 'outlook',
  'outlook calendar': 'outlook',
  'google calendar': 'google-calendar',
  slack: 'slack',
  'microsoft teams': 'microsoft-teams',
  github: 'github',
  jira: 'jira',
  hubspot: 'hubspot',
  stripe: 'stripe',
  paypal: 'paypal',
  datadog: 'datadog',
  opsgenie: 'opsgenie',
  sentry: 'sentry',
  postman: 'postman',
  zoom: 'zoom',
  'google meet': 'google-meet',
  linkedin: 'linkedin',
  salesforce: 'salesforce',
  hunter: 'hunter',
  calendly: 'calendly',
  notion: 'notion',
  hootsuite: 'hootsuite',
  confluence: 'confluence',
  'google drive': 'googledrive',
  supabase: 'supabase',
  quickbooks: 'quickbooks',
  xero: 'xero',
  fireflies: 'fireflies',
  clickup: 'clickup',
  asana: 'asana',
  perplexity: 'perplexity',
  linear: 'linear',
  gong: 'gong',
  airtable: 'airtable',
  dropbox: 'dropbox',
  clio: 'clio',
  doordash: 'doordash',
  browser: 'browser',
  webhook: 'webhook',
  phone: 'phone',
  rss: 'rss',
}
